module.exports = __webpack_public_path__ + "static/media/notpragram2.1ed4ed6f.png";